import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let _routes = {
    'goods-collection': [
        'selectt',
        'country',
        'warehouseCheck',
    ],
    'head-logistics': [
        'putInStorage',
        'barCode',
        "clearanceOfGoods",
        "logisticsDelivery",
        "sweep",
    ],
    'overseas-warehouses':[
        'simulationCase',
        'checkAndRatify',
        'handleOrdersOne',
        'handleOrdersTwo',
        'moveStorehouse',
        'handleOrdersTwoSweep',
        'handleOrdersTwoDeliver',
        'handleOrdersThree',
        'putInStorage',
        'barCode',
        "clearanceOfGoods",
        "logisticsDelivery",
        "sweep",
        'handleOrdersThreeDeliver'
    ],
    'order-to-sign-for':[
        'signFor'
    ],
    'finish-experiment':[
        'report'
    ]
}


let routes = [
    {
        path: '/',
        name: 'default',
        component: () => import('../layout/default'),
        children: []
    },
    {
        path:'/start',
        component:()=> import('./../views/start')
    }
];
let i = 0;
for(let key in _routes){
    let parent = {
        path:key,
        component: {render: (e) => e("router-view")},
        children:[]
    }
    _routes[key].forEach((item,index)=>{
        let children = {
            path: item,
            component: () => import(`./../views/${key}/${item}`),
            meta:{
                prev:_routes[key][index-1]?`/${key}/${_routes[key][index-1]}`:null,
                next:_routes[key][index+1]?`/${key}/${_routes[key][index+1]}`:null,
            }
        }
        parent.children.push(children)
    })
    routes[0].children.push(parent)
    i++;
}


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
